import * as React from 'react';
import * as styles from '../dashboards.module.scss';
import { withRouter, RouteComponentProps } from 'react-router';
import TertiaryButton from '../../../../common/tertiary-button';
import Paths from '../../../../../models/enums/paths';
import Dashboard from '../../../../../models/dashboard';

interface Props extends RouteComponentProps {
  clientId: number;
  dashboard: Dashboard;
}

/**
 * @function DashboardEntry
 */
const DashboardEntry = ({ clientId, dashboard, history }: Props) => {
  const redirectToEditDashboard = () => {
    history.push(
      Paths.EditClientDashboard.replace(':clientId', String(clientId)).replace(
        ':dashboardId',
        dashboard.reportId.toString()
      )
    );
  };

  let dashboardTags = '';
  if (dashboard.assignedTags) {
    dashboardTags = dashboard.assignedTags.map(tag => tag.name).join(',');
  }

  return (
    <tr>
      <td>{dashboard.name}</td>
      <td className={styles.descriptionCol} title={dashboard.description}>
        {dashboard.description}
      </td>
      <td className={styles.tagsCol} title={dashboardTags}>
        {dashboardTags}
      </td>
      <td>{dashboard.reportId}</td>
      <td>{dashboard.status === true ? 'ACTIVE' : 'INACTIVE'}</td>
      <td className={styles.actionCol}>
        <TertiaryButton text="Edit Dashboard" title="Edit Dashboard" handleClick={() => redirectToEditDashboard()} />
      </td>
    </tr>
  );
};

export default withRouter(DashboardEntry);
